module.exports = __webpack_public_path__ + "static/img/img05.1d5f9eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c38/img05.png
// module id = AFpQ
// module chunks = 0